<template>
  <div class="text-center mt-15">
    <div v-if="cart.cart_products.length" class="d-block d-sm-block d-md-none">
      <!--esto se muestra en moviles-->
      <div class="row" v-for="item in cart.cart_products" :key="item.id">
        <div class="col-sm-5 col-xs-5 col-5">
          <img
            :src="item.product.url_image_detail"
            :alt="item.product.name"
            class="img-product-cart"
          />
        </div>
        <div class="col-sm-5 col-xs-5 col-7 d-flex justify-space-between align-items-center">
          <div>
            <p class="h5 mt-2 color-blue font-general-l font-weight-bold">
              {{ item.product.name }}
            </p>
            <span class="h5 color-blue font-general-l">{{ item.option_size }}</span>
            <br>
            <v-btn
              v-if="item.hasOwnProperty('id')"
              color="accent"
              text
              :loading="loading_btn_remove_cart"
              @click="removeItemCart(item.id)"
            >
              <v-icon>mdi-minus</v-icon>
            </v-btn>
            <v-btn
              v-else
              color="accent"
              text
              :loading="loading_btn_remove_cart"
              @click="removeItemCart(item.product.id)"
            >
              <v-icon>mdi-minus</v-icon>
            </v-btn>
            <span class="h5 color-blue font-general-l font-weight-bold">{{ item.quantity }}</span>
          </div>
          <div>
            <p class="h5 color-blue font-general-l font-weight-bold">
              {{
                currencyFormat(item.subtotal)
              }}
            </p>
          </div>
        </div>
      </div>
      <!-- <div class="border-nv mb-10 mt-5" style="background-color: blue;"></div> -->
      <!-- <div class="row h5 color-blue font-general-l font-weight-bold ">
        <div class="col-8 ">
          SUBTOTAL
        </div>
        <div class="col-4">
          {{ currencyFormat(total_cart) }}
        </div>
      </div>
      <div class="row h5 color-blue font-general-l font-weight-bold">
        <div class="col-4">
          ENVÍOS
        </div>
        <div class="col-4">
          PICKUP
        </div>
        <div class="col-4">
          GRATIS
        </div>
      </div> -->




      <!-- <div class="row">
        <div class="col color-blue font-general-r">
          <div class="border-nv mb-10 mt-10"></div>
          <h5>
            {{ cart.cart_products.length }} {{ cart.cart_products.length > 1 ? 'productos' : 'producto' }} en tu bolsa
          </h5>
          <h5>SUBTOTAL: {{ currencyFormat(total_cart) }}</h5>
          <div class="text-right">
            <v-btn
              @click="continueBuy()"
              color="secondary"
              class="nv-btn nv-btn-large pa-5"
              elevation="0"
            >
              SEGUIR COMPRANDO
            </v-btn>
            <v-btn
              @click="checkout()"
              color="primary"
              class="nv-btn nv-btn-hover nv-btn-large pa-5"
              elevation="0"
            >
              FINALIZAR PEDIDO
            </v-btn>
          </div>
        </div>
      </div> -->
    </div>

    <div v-if="!cart.cart_products.length">
      <p class="text-center m-0 pb-5 h3 color-blue font-general-r">Tu carrito esta vacio.</p>
    </div>

    <v-btn
      :loading="loading_btn_clean_cart"
      @click="cleanCart()"
      color="primary"
      class="nv-btn nv-btn-large pa-0 mb-2 rounded-pill"
      elevation="0"
    >
      VACIAR CARRITO
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { currencyFormat } from '@/helpers'
//import HomeService from '@/services/home.service'
// import ItemCart from '@/components/store/ItemCart'
// import ItemSlideFlavor from '@/components/store/ItemSlideFlavor'
// import CartMobile from '@/components/store/mobile/CartMobile'

export default {
  props: ['flavors'],
  components: {
    // ItemCart,
    // CartMobile,
    // ItemSlideFlavor
  },
  data: () => ({
    added_cart: false,
    loading_btn_remove_cart: false,
    loading_btn_clean_cart: false
  }),
  computed: {
    ...mapState(['cart', 'is_auth', 'user', 'data_home_page', 'number_day']),
    ...mapGetters(['total_cart'])
  },
  watch: {
    open_cart(newval) {
      if (newval) {
        this.refreshFlavorArray()
      }
    }
  },
  methods: {
    openSnackCart() {
      this.$refs.snackbarCart.open()
    },
    removeItemCart(item_id) {
			try {
        this.loading_btn_remove_cart = true
        setTimeout(() => {
          this.$store.dispatch('removeItemCart', { id: item_id })
          this.loading_btn_remove_cart = false
        }, 500)
			} catch (error) {
				this.$notify({
					group: 'admin',
					title: 'Ocurrio un problema: '.error.message,
					type: 'success',
				})
			}
		},
    checkout() {
      this.$emit('closeModal')
      this.$router.push('/procesar-pago')
    },
    async cleanCart() {
      this.loading_btn_clean_cart = true
      await this.$store.dispatch('cleanCart')
      this.loading_btn_clean_cart = false
		},
    refreshFlavorArray() {
      let flavors_cart_id = this.cart.cart_products.map(i => {
        return i.product.id
      })
      this.data_home_page.flavors.forEach(i => {
        if (!flavors_cart_id.includes(i.id)) {
          this.flavors.push(i)
        }
      })
    },
    pushFlavor(flavor) {
      this.open_cart = false
      location.href = `/helado-sabor/${flavor.slug}/${flavor.id}`
    },
    continueBuy() {

      let route = this.$route.name
      this.$emit('closeModal')
			if (route != 'Home') {
        this.$router.push({path: '/', hash: '#sabores'})
			} else {
				const offsetTop = document.querySelector('#sabores').offsetTop;
				scroll({
					top: offsetTop,
					behavior: "auto"
				});
			}

      //this.$router.push({path: '/', hash: 'sabores'})
      /*const offsetTop = document.querySelector().offsetTop;
      scroll({
        top: offsetTop + sum,
        behavior: "auto"
      });*/
    },
    currencyFormat(price) {
			return currencyFormat(price)
		}
  }
}
</script>
<style >

</style>
